module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-bottom-01.2@2x.8f1cbc2b.jpg";